import moment from "moment-timezone";
import React from "react";
import { convertDateToLocalDeadlineMoment } from "utils/timezones";

interface TimezoneTitleSpanProps {
  dateValue?: string | null;
  timezone?: string | null;
  children: React.ReactNode;
}

const TimezoneTitleSpan: React.FC<TimezoneTitleSpanProps> = ({ dateValue, timezone, children }) => {
  let title = "-";

  const localDate = convertDateToLocalDeadlineMoment(dateValue, timezone);

  if (localDate) {
    const localZone = moment.tz.guess();

    const timezoneAbbr = localDate.format("z");

    title = `${localDate.format("MMM DD, YYYY hh:mm A")} ${
      timezoneAbbr ? `${timezoneAbbr} (${localZone})` : localZone
    }`;
  }

  return <span title={title}>{children}</span>;
};

export default TimezoneTitleSpan;
